var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBurned = function SvgBurned(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download_3_",
    "data-name": "download (3)",
    d: "M214.876,172.116c-2.2.561-3.043,1.415-3.651,3.23.264-1.9.159-7.128-6.482-9.611,1.191,3.5,1.164,8.97-.847,10.6.635-2.162-1.058-4.031-2.7-5.393.953,5.58-5.794,6.567-3.228,13.616a8.514,8.514,0,0,0,4.842,4.645c-1.4-3.738,1.878-8.81,4.233-9.878-.714,1.789.82,4.459,1.773,5.072a2.4,2.4,0,0,1,.582-2.67c.185,2.8,4.207,4.165,2.619,8.009a7.847,7.847,0,0,0,5.265-6.3c.794-4.351-3.413-7.715-2.407-11.32Z",
    transform: "translate(-197.383 -165.735)",
    fill: "#6699c9"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurned, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burned.63f9681a.svg";
export { ForwardRef as ReactComponent };